import React, { FC } from 'react';
import { StepWizardChildProps } from 'react-step-wizard';
import { FormProvider } from 'react-hook-form';
import { TextVariant } from '@naf/text';
import { Message } from '@naf/input';
import { GridCol, GridRow } from '@naf/grid';
import { CampaignCodeInput } from '@pages/BecomeAMember/components/CampaignCodeInput/CampaignCodeInput';
import { WizardNavigation } from '../../components/WizardNavigation';
import { Summary } from '../../components/Summary';
import { AddonForm } from './Form';
import { HouseholdMemberAddon } from './HouseholdMemberAddon';
import { useAddonsFormLogic } from './useAddonsFormLogic';
import S from './Styles';

export const Addons: FC<Partial<StepWizardChildProps>> = ({
  totalSteps,
  currentStep,
  nextStep,
  previousStep,
  goToStep,
}) => {
  const {
    form,
    errors,
    availableAddonProducts,
    addonProductsDescription,
    supportsHouseholdMember,
    householdMemberPrice,
    isHouseholdMemberSelected,
    selectedHouseholdMember,
    members,
    products,
    mainMemberServerMessages,
    householdMemberErrors,
    handleHouseholdMemberToggle,
    onSubmit,
    onGoback,
  } = useAddonsFormLogic({ goToStep });
  const { control, getValues, handleSubmit, setValue, unregister, watch } = form;

  return (
    <GridRow>
      {/* FormProvider expects the complete useForm return object. */}
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <FormProvider {...form}>
        <GridCol s="12" m="12" l="7" xl="7">
          <S.FirstHeading variant={TextVariant.Header2}>Tilleggsvalg</S.FirstHeading>
          {mainMemberServerMessages.length > 0 && (
            <S.FieldWrapper>
              <Message error>{`Det er feil i Om meg: ${mainMemberServerMessages.join(', ')}`}</Message>
            </S.FieldWrapper>
          )}
          {supportsHouseholdMember && (
            <HouseholdMemberAddon
              control={control}
              errors={householdMemberErrors}
              householdMemberPrice={householdMemberPrice}
              isSelected={isHouseholdMemberSelected}
              member={selectedHouseholdMember}
              onChange={handleHouseholdMemberToggle}
            />
          )}
          <AddonForm
            availableAddOnProducts={availableAddonProducts}
            membersOverride={members}
            control={control}
            handleSubmit={handleSubmit}
            errors={errors}
            watch={watch}
            getValues={getValues}
            setValue={setValue}
            unregister={unregister}
          />
          <S.Description>{addonProductsDescription}</S.Description>
        </GridCol>
        <Summary products={products}>
          <CampaignCodeInput />
        </Summary>
        <GridCol s="12" m="12" l="12" xl="12">
          <WizardNavigation
            totalSteps={totalSteps}
            currentStep={currentStep}
            nextStep={nextStep}
            previousStep={previousStep}
            trackingStep={2}
            isValid={Object.values(errors).length === 0}
            onSubmit={onSubmit}
            onGoback={onGoback}
            getValues={getValues}
          />
        </GridCol>
      </FormProvider>
    </GridRow>
  );
};
